"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var bind_1 = require("../../bind");
var lodash_1 = require("lodash");
var elog = require("../../elog");
var url_helpers_1 = require("../../url_helpers");
var marketing_callout_card_1 = require("./marketing_callout_card");
var overflowing_row_1 = require("../../components/overflowing_row");
var sanitized_render_1 = require("../../components/sanitized_render");
var tiles_1 = require("../../components/tiles");
var core_link_1 = require("../../components/core_link");
var SIDEBAR_SECTION = 'sidebar';
var COMPONENT_NAME = 'CMSPageCards';
var CARDS = 'cards';
var TEXT_ONLY = 'textOnly';
exports.DISPLAY_AS = [
    CARDS,
    TEXT_ONLY,
];
var CmsPageCards = /** @class */ (function (_super) {
    tslib_1.__extends(CmsPageCards, _super);
    function CmsPageCards() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CmsPageCards.prototype.getImageOverride = function (page) {
        var idx = this.props.pageFields.findIndex(function (p) { return p.slug === page.slug; });
        return this.props.pageFields[idx] && this.props.pageFields[idx].imageOverride;
    };
    CmsPageCards.prototype.getImageName = function (page) {
        var override = this.getImageOverride(page);
        if (override)
            return url_helpers_1.imageUploadURL(override);
        if (!page.image || !page.image.imageUrl)
            return null;
        return url_helpers_1.imageUploadURL(page.image.imageUrl.split('/upload/')[1]);
    };
    CmsPageCards.prototype.isInSidebar = function () {
        return (this.props.layoutSection === SIDEBAR_SECTION);
    };
    CmsPageCards.prototype.cmsPages = function () {
        return lodash_1.get(this.props, 'data.cmsPages.pages', []);
    };
    CmsPageCards.prototype.renderCard = function (cmsPage, idx) {
        if (this.props.displayAs === TEXT_ONLY) {
            var styles = "color-gray width-100 height-100 hoverable-shadow\n        d-flex fx-align-center fx-justify-between size-110 bg-white";
            return (React.createElement(core_link_1.default, { className: styles, to: url_helpers_1.CMSPageURL(cmsPage), key: idx },
                React.createElement("div", { className: "weight-bold scaling-padding-2" }, cmsPage.title),
                React.createElement("span", { className: "icon-r-arrow-right scaling-padding-2 pl-0" })));
        }
        return (React.createElement(marketing_callout_card_1.default, { title: cmsPage.title, imageURL: this.getImageName(cmsPage), targetHref: url_helpers_1.CMSPageURL(cmsPage), pageType: cmsPage.pageType, channel: cmsPage.channels[0] || 'core', key: idx }));
    };
    CmsPageCards.prototype.renderTitle = function () {
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    CmsPageCards.prototype.render = function () {
        if (!this.cmsPages())
            return null;
        if (!this.cmsPages().length)
            return null;
        try {
            return (React.createElement(overflowing_row_1.default, { title: this.renderTitle(), subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, id: this.props.jumplinkSlug, action: this.props.action },
                React.createElement(tiles_1.default, { grow: true, threeWide: !this.isInSidebar(), singleRow: !this.props.displayAsGrid && !this.isInSidebar(), oneWide: this.isInSidebar(), expectedCount: this.props.pageFields.length }, this.cmsPages().map(this.renderCard))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CmsPageCards.defaultProps = { pageFields: [] };
    tslib_1.__decorate([
        bind_1.default
    ], CmsPageCards.prototype, "renderCard", null);
    return CmsPageCards;
}(React.Component));
exports.CmsPageCards = CmsPageCards;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_Cms_PageCards(\n      $slugs: [String]\n    )\n    {\n      cmsPages(input: {\n        slugs: $slugs\n      }) {\n        pages {\n          slug\n          title\n          pageType\n          channels\n          image {\n            imageUrl\n          }\n        }\n      }\n    }\n  "], ["\n    query Core_Cms_PageCards(\n      $slugs: [String]\n    )\n    {\n      cmsPages(input: {\n        slugs: $slugs\n      }) {\n        pages {\n          slug\n          title\n          pageType\n          channels\n          image {\n            imageUrl\n          }\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            slugs: ownProps.pageFields.map(function (s) { return s.slug; }),
        },
    }); },
});
exports.default = connect(CmsPageCards);
var templateObject_1;
//# sourceMappingURL=cms_page_cards.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/cms_page_cards.js
// module id = o+iu
// module chunks = 20 21